import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import "./checkbox.css";
import { subject } from "../../service";
import { verifyAuth } from "../../authverify";
import { ADImage } from "../../style/Header";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import PanazCreative from "../NewCreatives/PanazCreative/PanazCreative";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import PanazVerticalAd from "../../assets/Ads/PanazV.jpg";






const headerMap = {
  1: MedizenVerticalAd,
  2: PrimeraVerticalAd,
  3: PanazVerticalAd,
};


export default class Blood extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: window.sessionStorage.getItem("keyselected"),
      headerImg: "",
      leftImg: "Ads/Vertical1.jpeg",
      checkItems: {}
    };
    this.handleChange = this.handleChange.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
  }
  handleChange = (event) => {
    if (event.target.checked) {
      if (event.target.value == "1") {
        this.state.headerImg = headerMap[1];
      } else if (event.target.value == "2") {
        this.state.headerImg = headerMap[2]
      } else {
        this.state.headerImg = headerMap[3]
        this.state.leftImg = "Ads/Vertical1.jpeg";
      }
    }

    this.sendMessage(event.target.value);
    sessionStorage.setItem("rValue", event.target.value);
  };

  sendMessage = (value) => {
    let imagesel = {
      imgsrc: value
    };

    subject.next(imagesel);
  };

  render() {
    return (
      <div
        style={{
          paddingTop: 10,
          paddingLeft: 40,
        }}
      >
        
        <Grid container spacing={1}>
          <Grid item md={4} style={{ marginTop: 20 }}>
            <FormControl
              key={this.state.checkItems}
              component="fieldset"
              sx={{ fontSize: "2px", fontWeight: 600 }}
            >
              <FormGroup
                aria-label="position"
                coloumn
                sx={{ fontSize: "2px", fontWeight: 600 }}
              >
                <FormControlLabel
                  value="1"
                  control={
                    <Checkbox
                      className="clickable"
                      onChange={this.handleChange}
                    />
                  }
                  label="Urine culture"
                  labelPlacement="Urine culture"
                />
                <FormControlLabel
                  value="2"
                  control={
                    <Checkbox
                      className="clickable"
                      onChange={this.handleChange}
                    />
                  }
                  label="Complete Blood Count (CBC)"
                  labelPlacement="Complete Blood Count (CBC)"
                />
                <FormControlLabel
                  value="Routine Blood"
                  control={<Checkbox disabled />}
                  label="Routine Blood"
                  labelPlacement="Routine Blood"
                />
                <FormControlLabel
                  value="TLC"
                  control={<Checkbox disabled />}
                  label="TLC"
                  labelPlacement="TLC"
                />
                <FormControlLabel
                  value="APTT"
                  control={<Checkbox disabled />}
                  label="APTT"
                  labelPlacement="APTT"
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item md={4} style={{ marginTop: 20 }}>
            <FormControl component="fieldset">
              <FormGroup aria-label="position" coloumn >
                <FormControlLabel
                  value="3"
                  control={
                    <Checkbox
                      className="clickable"
                      onChange={this.handleChange}
                    />
                  }
                  label="GFR Blood test"
                  labelPlacement="GFR Blood test"
                />
                <FormControlLabel
                  value="2"
                  control={
                    <Checkbox
                      className="clickable"
                      onChange={this.handleChange}
                    />
                  }
                  label="WBC count"
                  labelPlacement="WBC count"
                />
                <FormControlLabel
                  value="Haemogram"
                  control={<Checkbox disabled />}
                  label="Haemogram"
                  labelPlacement="Haemogram"
                />
                <FormControlLabel
                  value="CBC"
                  control={<Checkbox disabled />}
                  label="ANC (Blood)"
                  labelPlacement="ANC (Blood)"
                />
                <FormControlLabel
                  value="Blood Banking"
                  control={<Checkbox disabled />}
                  label="Blood Banking"
                  labelPlacement="Blood Banking"
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item md={4} style={{ marginTop: 20 }}>
            <FormControl component="fieldset">
              <FormGroup aria-label="position" coloumn>
                <FormControlLabel
                  value="2"
                  control={
                    <Checkbox
                      className="clickable"
                      onChange={this.handleChange}
                    />
                  }
                  label="HbA1c (Blood Glucose)"
                  labelPlacement="HbA1c (Blood Glucose)"
                />
                <FormControlLabel
                  value="3"
                  control={
                    <Checkbox
                      className="clickable"
                      onChange={this.handleChange}
                    />
                  }
                  label="Complete Blood Profile (RBC,CBC,WBC,P)"
                  labelPlacement="Complete Blood Profile (RBC,CBC,WBC,P)"
                />
                <FormControlLabel
                  value="Basophil (Blood)"
                  control={<Checkbox disabled />}
                  label="Basophil (Blood)"
                  labelPlacement="Basophil (Blood)"
                />
                <FormControlLabel
                  value="Total Leucocyte Count"
                  control={<Checkbox disabled />}
                  label="Total Leucocyte Count"
                  labelPlacement="Total Leucocyte Count"
                />
                <FormControlLabel
                  value="Total Leucocyte Count"
                  control={<Checkbox disabled />}
                  label="RBC indices"
                  labelPlacement="RBC indices"
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </div>
    );
  }
}
